<div class="password-header">
  <ag-breadcrumb currentPath="Change password" [bold]="true"></ag-breadcrumb>
</div>
<div class="password-main-content">
  <div class="white-box-with-image">
    <div style="display: flex; flex-direction: column; gap: 16px; padding: 24px">
      <input type="text" name="fake-user" autocomplete="off" style="display: none" />
      <input type="password" name="fake-pass" autocomplete="new-password" style="display: none" />
      <ag-input-field [simpleVersion]="true" [disable]="true" [styles]="{ specificWidth: '400px', specificHeight: '48px' }" [initValue]="email" label="Email"></ag-input-field>

      <ag-input-field [simpleVersion]="!oldPasswordInfo.showInfo" [info]="oldPasswordInfo" [styles]="{ specificWidth: '400px', specificHeight: '48px' }" label="Old password" inputType="password" [isPassword]="true" (changeResult)="changeOld($event)"></ag-input-field>
      <ag-input-field [simpleVersion]="!newPasswordInfo.showInfo" [info]="newPasswordInfo" [styles]="{ specificWidth: '400px', specificHeight: '48px' }" label="New password" inputType="password" [isPassword]="true" (changeResult)="changeNew($event)"></ag-input-field>
      <ag-input-field [simpleVersion]="!confirmNewPasswordInfo.showInfo" [info]="confirmNewPasswordInfo" [styles]="{ specificWidth: '400px', specificHeight: '48px' }" label="Confirm new password" inputType="password" [isPassword]="true" (changeResult)="changeConfirm($event)"></ag-input-field>
      <div (click)="changePassWord()" style="display: flex; width: 100%; justify-content: center">
        <ag-button-v2 [disabled]="!canSave()" specificWidth="200px" color="green" label="Change password"></ag-button-v2>
      </div>
    </div>
    <div class="grey-box">
      <img width="360" height="360" [src]="iconService.Illustration.tools" />
    </div>
  </div>
</div>
